<template>
  <div>
    <vue-tel-input
      :name="name"
      :inputId="name"
      @input="send"
      @change="send"
      :required="required"
      inputClasses="form-control form-control-sm"
      v-model="post"
    ></vue-tel-input>
  </div>
</template>

<script>
import { VueTelInput } from "vue-tel-input";

export default {
  props: ["name", "validation", "content"],
  data() {
    return {
      post: this.content
    };
  },
  components: {
    VueTelInput
  },
  computed: {
    required() {
      if (this.validation == "required") {
        return true;
      }

      return false;
    }
  },
  methods: {
    send() {
      console.log("ok");

      this.$emit("post", {
        name: this.name,
        value: this.post
      });
    }
  }
};
</script>